import { render, staticRenderFns } from "./ServiceTypeDialog.vue?vue&type=template&id=13939b2c"
import script from "./ServiceTypeDialog.vue?vue&type=script&lang=js"
export * from "./ServiceTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports